/** "1.0.11" 같은 버전 문자열 비교. a<b → 음수, 같으면 0, a>b → 양수 */
export function compareVersion(a: string, b: string): number {
  const pa = a.split(".").map((n) => parseInt(n, 10) || 0);
  const pb = b.split(".").map((n) => parseInt(n, 10) || 0);
  const len = Math.max(pa.length, pb.length);
  for (let i = 0; i < len; i++) {
    const diff = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (diff !== 0) return diff;
  }
  return 0;
}

/** 설치된 버전이 최신보다 낮은가 (둘 중 하나라도 모르면 false) */
export function isOutdatedVersion(current: string | null | undefined, latest: string | null | undefined): boolean {
  return !!current && !!latest && compareVersion(current, latest) < 0;
}
